import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const SLIDES = [
  {
    title: 'Duty on the move',
    body: 'Start and end duty from the Phirti mobile app. The web app shows live status, distance, and your duty log.',
  },
  {
    title: 'Live team map',
    body: 'See who’s on duty right now, their last location, and open a member’s route for the current session.',
  },
  {
    title: 'Check-ins with photos',
    body: 'Field check-ins capture notes and photos while on duty so supervisors can review what happened on site.',
  },
  {
    title: 'Team & duty log',
    body: 'Filter by member and date range, download PDF or Excel, and optionally email the duty log on a schedule.',
  },
  {
    title: "You're set",
    body: 'Pick your Company Workspace, open Phirti, and keep duty tracking simple for the whole team.',
  },
] as const;

export function QuickGuidePage() {
  const navigate = useNavigate();
  const [index, setIndex] = useState(0);
  const slide = SLIDES[index];
  const last = index === SLIDES.length - 1;

  return (
    <div className="auth-screen">
      <div
        style={{
          minHeight: '100%',
          background: 'linear-gradient(180deg, #e8f2ff 0%, #f5f7fb 40%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 24,
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: 440,
            background: '#fff',
            borderRadius: 16,
            padding: 28,
            boxShadow: '0 8px 40px rgba(0,50,120,0.08)',
          }}
        >
          <div style={{ textAlign: 'center', marginBottom: 20 }}>
            <img
              src="/phirti-logo.png"
              alt=""
              width={72}
              height={72}
              style={{ borderRadius: 16, marginBottom: 12, objectFit: 'cover' }}
            />
            <div style={{ fontSize: 13, fontWeight: 600, color: '#007AFF', letterSpacing: 0.4 }}>
              Phirti
            </div>
            <h1 style={{ fontSize: 24, margin: '8px 0 0' }}>{slide.title}</h1>
            <p style={{ color: '#636366', lineHeight: 1.5, marginTop: 12 }}>{slide.body}</p>
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              gap: 8,
              marginBottom: 24,
            }}
          >
            {SLIDES.map((_, i) => (
              <span
                key={i}
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  background: i === index ? '#007AFF' : '#d1d1d6',
                }}
              />
            ))}
          </div>

          <div style={{ display: 'flex', gap: 12 }}>
            {index > 0 ? (
              <button
                type="button"
                className="ph-btn ph-btn--ghost"
                style={{ flex: 1 }}
                onClick={() => setIndex((i) => i - 1)}
              >
                Back
              </button>
            ) : (
              <button
                type="button"
                className="ph-btn ph-btn--ghost"
                style={{ flex: 1 }}
                onClick={() => navigate('/')}
              >
                Skip
              </button>
            )}
            <button
              type="button"
              className="ph-btn"
              style={{ flex: 1 }}
              onClick={() => {
                if (last) navigate('/');
                else setIndex((i) => i + 1);
              }}
            >
              {last ? 'Open Phirti' : 'Next'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
